import { useState } from "react";
import { Container, Col, Form, Button, Alert } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

const Login = () =>  {
    const API = process.env.REACT_APP_API_BASE_URL;
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [formFeedback, setFormFeedback] = useState({
        success: null,
        message: "",
    });
    const navigate = useNavigate();
    const location = useLocation();

    const handleChange = (e) => {
        const { name, value } = e.target;
        name === "username" ? setUsername(value) : setPassword(value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormFeedback({ status: null, message: "" }); // Reset form feedback
        setIsLoading(true);

        /* Make API call */
        fetch(`${API}/login/`, {
            method: 'POST',
            body: JSON.stringify({
                username: username,
                password: password,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if (data.success) {
                setFormFeedback({ success: true, message: "Log in successful. Redirecting to admin panel..."});
                navigate(location.state?.from || "/dashboard", { replace: true }); /* Navigate to page user tried to access before login or default to admin dashboard */
            } else {
                setIsLoading(false);
                setFormFeedback({ success: false, message: "Incorrect credentials. Please try again." });
            }
        })
        .catch((error) => {
            setIsLoading(false);
            setFormFeedback({ success: false, message: "An error has occured." });
            console.error(error);
        })
        .finally(() => {
            // Clear notification message after 7 seconds
            if (formFeedback.success) {
                setTimeout(() => setFormFeedback({  status: null, message: "" }), 7000);
            }
        });
    }

    return (
        <Container fluid className="flex-grow-1 d-flex align-items-center justify-content-center">
            <Col sm={8} md={6} lg={5} xl={4} className="border py-5 px-3 px-lg-5" style={{ position: "relative", zIndex: "10", backgroundColor: "#FFF" }}>
                <h3 className="text-center mb-4 px-3">Sign in to Admin Dashboard</h3>
                <Form className="d-flex flex-column gap-3" onSubmit={ handleSubmit }>
                    {/* {isLoading && <Spinner animation="border" variant="primary" className="mx-auto" />} */}

                    {formFeedback.success != null &&
                        <Alert variant={ formFeedback.success ? "primary" : "danger" } className="my-3 text-center">
                            { formFeedback.message }
                        </Alert>
                    }

                    <Form.Group>
                        <Form.Label htmlFor="username">Username</Form.Label>
                        <Form.Control
                            id="username"
                            type="username"
                            name="username"
                            value={ username }
                            onChange={ handleChange }
                            autoComplete="username"
                            required
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label htmlFor="password">Password</Form.Label>
                        <Form.Control
                            id="password"
                            type="password"
                            name="password"
                            value={ password }
                            onChange={ handleChange }
                            autoComplete="current-password"
                            required
                        />
                    </Form.Group>
                    <Button className="w-100 mt-3" type="submit">
                        {isLoading ? "Logging in..." : "Log in"}
                    </Button>
                </Form>
            </Col>
        </Container>
    );
};

export default Login;